import type { ReactNode } from 'react';

import type { AlertProps } from '@mui/material';

import { create } from 'zustand';

export type ToastMessageSeverity = AlertProps['severity'];

interface SnackbarState {
  isVisible: boolean;
  title: ReactNode;
  message: ReactNode;
  autoHide: boolean;
  severity: ToastMessageSeverity;
  showSnackbar: (message: ReactNode, severity: ToastMessageSeverity, autoHide: boolean, title?: ReactNode) => void;
  hideSnackbar: () => void;
  clearSnackbar: () => void;
}

export const SNACKBAR_STORE = create<SnackbarState>((set) => ({
  isVisible: false,
  title: '',
  message: '',
  autoHide: false,
  severity: 'success',
  showSnackbar: (message, severity, autoHide, title) =>
    set({
      isVisible: true,
      message,
      autoHide,
      severity,
      title
    }),
  hideSnackbar: () =>
    set({
      isVisible: false
    }),
  clearSnackbar: () =>
    set({
      title: '',
      message: '',
      autoHide: false,
      severity: 'success'
    })
}));
